import { render } from "./IconEducation.vue?vue&type=template&id=e34b58ec"
import script from "./IconEducation.vue?vue&type=script&lang=js"
export * from "./IconEducation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__